import React, { useState, useEffect, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import api from "../services/api";

export default function Scanner() {
  const [result, setResult] = useState(null);
  const [support, setSupport] = useState(null);
  const [error, setError] = useState(null);
  const scannerRef = useRef(null);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 }, false);
    scanner.render(
      async decoded => {
        scanner.clear();
        setResult(decoded);
        try {
          const id = decoded.split("/support/").pop().split("/").shift();
          const r = await api.get(`/qr/scan/${id}`);
          setSupport(r.data);
        } catch { setError("Support non trouvé pour ce QR code"); }
      },
      err => {}
    );
    scannerRef.current = scanner;
    return () => { scanner.clear().catch(() => {}); };
  }, []);

  const reset = () => { setResult(null); setSupport(null); setError(null); window.location.reload(); };

  const STATUTS = { actif: "#28a745", inactif: "#6c757d", maintenance: "#F5A800", reforme: "#dc3545" };

  return (
    <div style={{ padding: 32, maxWidth: 700, margin: "0 auto" }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1B3A8C", marginBottom: 8 }}>Scanner QR Code</h1>
      <p style={{ color: "#888", marginBottom: 24 }}>Scannez le QR code d'un support pour voir ses informations</p>
      {!result && <div id="reader" style={{ borderRadius: 12, overflow: "hidden" }} />}
      {error && <div style={{ background: "#fff3f3", border: "1px solid #dc3545", borderRadius: 12, padding: 20, color: "#dc3545", marginTop: 20 }}>❌ {error} <button onClick={reset} style={{ marginLeft: 12, background: "#dc3545", color: "#fff", border: "none", borderRadius: 6, padding: "4px 12px", cursor: "pointer" }}>Réessayer</button></div>}
      {support && (
        <div style={{ background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 4px 20px rgba(0,0,0,0.1)", marginTop: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
            <div>
              <h2 style={{ fontSize: 22, fontWeight: 800, color: "#1B3A8C" }}>{support.nom}</h2>
              <div style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Code: <b>{support.code}</b></div>
            </div>
            <span style={{ background: STATUTS[support.statut]+"22", color: STATUTS[support.statut], padding: "6px 16px", borderRadius: 20, fontWeight: 700, fontSize: 13 }}>{support.statut}</span>
          </div>
          {support.photo && <img src={support.photo} alt={support.nom} style={{ width: "100%", height: 200, objectFit: "cover", borderRadius: 10, marginBottom: 16 }} />}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {[["Catégorie", support.Categorie?.nom], ["Localisation", support.localisation], ["Adresse", support.adresse], ["Propriétaire", support.proprietaire]].filter(([,v]) => v).map(([k,v]) => (
              <div key={k} style={{ background: "#f8f9fa", borderRadius: 8, padding: "10px 14px" }}>
                <div style={{ fontSize: 11, color: "#888", fontWeight: 600 }}>{k}</div>
                <div style={{ fontSize: 14, color: "#333", marginTop: 2 }}>{v}</div>
              </div>
            ))}
          </div>
          <button onClick={reset} style={{ marginTop: 20, width: "100%", padding: 12, background: "#1B3A8C", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, cursor: "pointer", fontSize: 14 }}>📷 Scanner un autre QR</button>
        </div>
      )}
    </div>
  );
}
